import { FirebaseError } from 'firebase/app';
import { isFirebaseAuthError } from '../hooks/useAuth/types.js';

function firebaseErrorDisplay(error: string | FirebaseError | undefined) {
  if (isFirebaseAuthError(error)) {
    switch (error.code) {
      case 'auth/invalid-verification-code':
        return 'Invalid verification code';
      case 'auth/tenant-id-mismatch':
      case 'auth/unsupported-tenant-operation':
        return 'This operation is not supported for this tenant';
      case 'auth/wrong-password':
        return 'Incorrect email address or password, please try again';
      case 'auth/user-not-found':
        return 'Incorrect email address or password, please try again';
      case 'auth/invalid-action-code':
        return 'The sign-in link has already been used once, is expired, or is invalid. Please request a new link.';
      default:
        return 'Something went wrong.';
    }
  }
  return 'Something went wrong.';
}

export { firebaseErrorDisplay };
